let activeStepClassMemorized = '';
let inactiveStepClassMemorized = '';

function filterClasses(classList) {
    // Assume that active star use only classes modifiers and that classes do not have __
    const classModifier = Array.from(classList).filter(cls => !cls.includes('__'));
    return classModifier[0];
}

function isStepActive(step) {
    // Assume that only active step has sections elements
    return step.querySelector(':scope > section') !== null;
}

export function getStepClasses() {
    if (activeStepClassMemorized && inactiveStepClassMemorized) {
        return {
            activeStepClass: activeStepClassMemorized,
            inactiveStepClass: inactiveStepClassMemorized
        }
    }

    const steps = document.querySelectorAll('fieldset[id*=bv-ips-step]');

    for (let i = 0, l = steps.length; i < l; i++) {
        const step = steps[i];
        const isActive = isStepActive(step);
        if (isActive) {
            activeStepClassMemorized = filterClasses(step.classList);
            if (inactiveStepClassMemorized) {
                break;
            }
        } else {
            inactiveStepClassMemorized = filterClasses(step.classList);
            if (activeStepClassMemorized) {
                break;
            }
        }
    }

    return {
        activeStepClass: activeStepClassMemorized,
        inactiveStepClass: inactiveStepClassMemorized
    }
}
